import { Chip, Stack } from '@mui/material';
import { KeyboardArrowRight, KeyboardDoubleArrowRight } from '@mui/icons-material';
import React from 'react';

export default function ReplenishmentPlanStatesTableBody({ states }: { states: string[] }): React.JSX.Element {
  if (!states || states.length === 0) {
    return <span>-</span>;
  }

  return (
    <Stack direction={'row'} alignItems={'center'} spacing={0.5} useFlexGap sx={{ flexWrap: 'nowrap' }}>
      {states.map((state, index) => (
        <React.Fragment key={state}>
          {index === 0 ? (
            <Chip label={state} sx={{ flexShrink: 0 }} />
          ) : (
            <Chip label={state} variant={'outlined'} sx={{ flexShrink: 0 }} />
          )}

          {/* Arrow after each state */}
          {index === states.length - 1 ? (
            <KeyboardDoubleArrowRight sx={{ fontSize: 14 }} />
          ) : (
            <KeyboardArrowRight sx={{ fontSize: 14 }} />
          )}
        </React.Fragment>
      ))}

      {/* Show cycle by repeating the first state */}
      {states.length > 1 && <Chip label={states[0]} sx={{ flexShrink: 0 }} />}
    </Stack>
  );
}
